<template>
  <b-row class="pr-3 mb-2">
    <b-col cols="9">
      <b-badge
        v-for="(badge, index) in badge_stack"
        v-b-tooltip.hover
        :title="badge.tooltip"
        :key="index"
        :variant="badge.variant"
        class="mr-2 mb-3 p-2 font-sm"
        pill
      >
        <template v-if="badge.display">
          <i v-if="badge.icon" :class="`${badge.icon} mr-2`" />{{ badge.name }}
        </template>
      </b-badge>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "InstrumentRunnerBadgeStack",
  props: {
    instance: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    badge_stack() {
      const {
        instrument,
        name,
        equipment_number,
        location,
        model_number,
        daily_capacity,
        runtime,
        runtime_display,
      } = this.instance;
      return [
        {
          name: instrument && instrument.name,
          icon: "fa fa-clipboard-list",
          tooltip: "Instrument",
          variant: "primary",
          display: !!(instrument && instrument.name),
        },
        {
          name,
          icon: "fal fa-microscope",
          tooltip: "Instance name",
          variant: "primary",
          display: !!name,
        },
        {
          name: equipment_number,
          icon: "fa fa-flask",
          tooltip: "Equipment number",
          variant: "warning",
          display: !!equipment_number,
        },
        {
          name: model_number,
          icon: null,
          tooltip: "Model number",
          variant: "warning",
          display: !!model_number,
        },
        {
          name: `${daily_capacity}/day`,
          icon: "fal fa-calendar",
          tooltip: "Daily capacity",
          variant: "success",
          display: !!daily_capacity,
        },
        {
          name: `${runtime}/${runtime_display}`,
          icon: null,
          tooltip: "Runtime",
          variant: "success",
          display: !!(runtime && runtime_display),
        },
        {
          name: location,
          icon: "fa fa-building",
          tooltip: "Location",
          variant: "",
          display: !!location,
        },
      ];
    },
  },
  methods: {},
};
</script>